const cache = { plan: null, tvConnection: null, box: null };
const updateCache = (key, value) => { cache[key] = value; };
const getCache = (key) => cache[key];

export { updateCache, getCache }